var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-currency-tips"},[_c('Header',{staticClass:"m-wap",attrs:{"extras":_vm.extras,"platform":"wap"}}),_c('div',{staticClass:"m-currency-content"},[_c('div',{staticClass:"m-icon-img-wap",style:({
        display:
          _vm.extraItem.extras('successImg.display') == 1 ? 'block' : 'none',
      })},[_c('img',{attrs:{"src":_vm.extraItem.extras('successImg.src'),"alt":""}})]),_c('div',{staticClass:"t-success-wap",style:({
        display:
          _vm.extraItem.extras('successTitle.display') == 1 ? 'block' : 'none',
        color: _vm.extraItem.extras('successTitle.color'),
        fontSize: _vm.isPreview
          ? ''
          : _vm.pxOrVw(_vm.extraItem.extras('successTitle.size')),
        fontWeight:
          _vm.extraItem.extras('successTitle.weight') == 'default'
            ? '500'
            : _vm.extraItem.extras('successTitle.weight'),
      })},[_vm._v(" "+_vm._s(_vm.extraItem.extras("successTitle.model") || "提交成功")+" ")]),_c('div',{staticClass:"t-success-desc-wap",style:({
        display:
          _vm.extraItem.extras('successText.display') == 1 ? 'block' : 'none',
        color: _vm.extraItem.extras('successText.color'),
        fontSize: _vm.isPreview
          ? ''
          : _vm.pxOrVw(_vm.extraItem.extras('successText.size')),
        fontWeight:
          _vm.extraItem.extras('successText.weight') == 'default'
            ? '400'
            : _vm.extraItem.extras('successText.weight'),
      })},[_vm._v(" "+_vm._s(_vm.extraItem.extras("successText.model") || "感谢您的参与，祝您工作愉快")+" ")]),(_vm.hasJoin)?_c('div',{staticClass:"t-success-desc-wap"},[_vm._v(" 再次填写，请点击这里"),_c('span',{staticClass:"u-again",on:{"click":_vm.goIndex}},[_vm._v("→GO!")])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }